interface OverrideMarkerProps {
  reason: string;
  className?: string;
}

export function OverrideMarker({ reason, className = '' }: OverrideMarkerProps) {
  return (
    <span className={`group relative inline-flex ${className}`}>
      <button
        type="button"
        title={reason}
        aria-label={`Override: ${reason}`}
        onPointerDown={(event) => event.stopPropagation()}
        onClick={(event) => event.stopPropagation()}
        className="rounded bg-amber-100 px-1.5 py-0.5 text-[10px] font-semibold text-amber-800"
      >
        Override
      </button>
      <span
        role="tooltip"
        className="pointer-events-none absolute bottom-full left-0 z-50 mb-1 hidden w-max max-w-64 rounded bg-gray-900 px-2 py-1 text-left text-xs font-normal text-white shadow-lg group-hover:block group-focus-within:block"
      >
        {reason}
      </span>
    </span>
  );
}
